import LegalSection from "@/pages/legal/components/LegalSection";

export default function TermsPage() {
  return (
    <>
      <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        Términos de Uso
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        Última actualización: 10 de septiembre de 2026
      </p>
      <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-[15px] md:leading-8">
        Bienvenido a VendeYa. Al acceder o utilizar nuestra plataforma de
        clasificados, aceptas los presentes Términos de Uso. Te recomendamos
        leerlos con atención antes de publicar anuncios o realizar cualquier
        transacción.
      </p>

      <div className="mt-8">
        <LegalSection title="1. Aceptación de los términos">
          <p>
            Al crear una cuenta, publicar un anuncio o navegar por VendeYa,
            aceptas quedar vinculado por estos Términos, junto con la Política de
            Privacidad y las Normas de la Comunidad. Si no estás de acuerdo con
            alguna de sus disposiciones, deberás abstenerte de utilizar el
            servicio.
          </p>
          <p>
            Podremos actualizar estos Términos en cualquier momento. Los cambios
            entrarán en vigor desde su publicación y te notificaremos las
            modificaciones sustanciales por los canales disponibles. El uso
            continuado del servicio tras una actualización implica tu aceptación
            de la nueva versión.
          </p>
        </LegalSection>

        <LegalSection title="2. Descripción del servicio e intermediación">
          <p>
            VendeYa es una plataforma de anuncios clasificados que actúa como
            intermediario técnico entre compradores y vendedores. No somos parte
            de la compraventa, no compramos ni vendemos los artículos anunciados
            y no garantizamos la existencia, calidad, seguridad o legalidad de los
            productos publicados por los usuarios.
          </p>
          <p>
            Nuestro rol se limita a facilitar un espacio para la publicación y
            el contacto entre las partes. Cualquier acuerdo, pago o intercambio
            se realiza directamente entre comprador y vendedor, bajo su exclusiva
            responsabilidad.
          </p>
        </LegalSection>

        <LegalSection title="3. Registro y cuentas por roles">
          <p>
            Para publicar anuncios es necesario crear una cuenta proporcionando
            información veraz, completa y actualizada. Eres responsable de
            mantener la confidencialidad de tus credenciales y de toda actividad
            que ocurra bajo tu cuenta.
          </p>
          <p>
            La plataforma distingue entre distintos roles: <strong>comprador</strong>,
            que consulta y contacta anuncios; <strong>vendedor</strong>, que publica
            y gestiona sus artículos; y <strong>administrador</strong>, encargado de
            moderar el contenido y velar por el cumplimiento de las normas. Cada
            rol cuenta con permisos y funciones específicos que no podrán ser
            eludidos ni suplantados.
          </p>
        </LegalSection>

        <LegalSection title="4. Normas de publicación">
          <p>
            Al publicar un anuncio te comprometes a que el artículo sea de tu
            propiedad o cuentes con autorización legítima para venderlo, que su
            descripción sea veraz y no induzca a error, y que las imágenes
            correspondan al producto real.
          </p>
          <p>
            Está prohibida la publicación de artículos ilegales, falsificados,
            robados o que vulneren derechos de terceros, así como cualquier
            contenido discriminatorio, ofensivo o que infrinja las Normas de la
            Comunidad. Nos reservamos el derecho de retirar, sin previo aviso,
            cualquier anuncio que incumpla estas disposiciones.
          </p>
        </LegalSection>

        <LegalSection title="5. Precios, comisiones y transacciones">
          <p>
            La publicación de anuncios básicos es gratuita. Determinadas funciones
            opcionales de visibilidad o promoción podrán tener un coste, que se
            informará de forma clara antes de su contratación.
          </p>
          <p>
            Los pagos entre usuarios se realizan a través de los medios acordados
            entre las partes. VendeYa no gestiona, retiene ni reembolsa el importe
            de las compraventas salvo en los casos expresamente indicados por los
            servicios de pago integrados.
          </p>
        </LegalSection>

        <LegalSection title="6. Limitación de responsabilidad">
          <p>
            VendeYa se presta "tal cual" y "según disponibilidad", sin garantías
            de disponibilidad continua o ausencia de errores. En la máxima medida
            permitida por la ley, no seremos responsables de daños directos o
            indirectos derivados del uso de la plataforma, de la calidad de los
            productos anunciados, ni de los perjuicios derivados de las
            transacciones entre usuarios.
          </p>
          <p>
            Tampoco responderemos por el contenido generado por los usuarios, si
            bien adoptamos medidas de moderación para preservar un entorno seguro
            y de confianza.
          </p>
        </LegalSection>

        <LegalSection title="7. Modificaciones y terminación">
          <p>
            Podemos modificar, suspender o discontinuar cualquier parte del
            servicio en cualquier momento. Asimismo, podremos suspender o cancelar
            cuentas que incumplan estos Términos o las Normas de la Comunidad.
          </p>
          <p>
            Podrás darte de baja en cualquier momento desde la configuración de tu
            cuenta. La terminación no eximirá de las obligaciones contraídas
            previamente.
          </p>
        </LegalSection>
      </div>
    </>
  );
}